import React, { useState, useEffect } from "react";

const Captcha = ({ length = 6, onChange }) => {
  const [captcha, setCaptcha] = useState("");

  const generateCaptcha = (captchaLength) => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < captchaLength) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    setCaptcha(result);
    if (onChange) {
      onChange(result);
    }
    return result;
  };

  useEffect(() => {
    generateCaptcha(length);
  }, [length]);

  return (
    <div className="d-flex justify-content-end">
      <div className="code position-relative">
        <div className="capcha">{captcha}</div>
        <i
          className="fa-solid fa-arrows-rotate refresh_icon"
          onClick={() => generateCaptcha(length)}
          style={{ cursor: "pointer" }}
        />
      </div>
    </div>
  );
};

export default Captcha; 